var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeposited(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65289 0.5H18.3471C19.26 0.5 20 1.30394 20 2.29564V8.58057H18.182V6.7849H1.81836V13.0693H10V14.8651H1.65289C0.740025 14.8651 0 14.0612 0 13.0695V2.29564C0 1.30394 0.740025 0.5 1.65289 0.5ZM18.182 2.29541V4.98926H1.81836V2.29541H18.182ZM19.4688 13.0695H15.2999L16.4752 14.2303L15.1896 15.5L11.8195 12.1717L15.1896 8.84335L16.4752 10.1131L15.2999 11.2739H19.4688V13.0695Z",
    fill: "#9295A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposited);
export default __webpack_public_path__ + "static/media/deposited.868aa422fc7f7bf112877cef9345ca7f.svg";
export { ForwardRef as ReactComponent };